import { createContext } from 'react'
import { AbbiamoUiHttpConfig } from '@seller-hermes/app/types'

const ConfigContext = createContext<AbbiamoUiHttpConfig>(
  {} as AbbiamoUiHttpConfig,
)

export default ConfigContext
